"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PocCloudTabs from "@/components/pageTabs/pocCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import WhyOneMind from "./components/whyOnemind";
import WhyChooseComponent from "./components/whyChoose";

const PocAsAServicePage = () => {
  return (
    <PageLayout showContactForm>
      <Hero />
      <PocCloudTabs />
      <Intro />
      <FeaturesComponent />
      <WhyOneMind />
      <WhyChooseComponent />
      <Faqs />
    </PageLayout>
  );
};

export default PocAsAServicePage;
